import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { useTranslation } from "react-i18next";

function ThemeToggle() {
  const { t } = useTranslation();
  const [dark, setDark] = useState(
    () => localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      dark ? "dark" : "light"
    );
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <button
      type="button"
      className="theme-button"
      onClick={() => setDark(!dark)}
      aria-label={dark ? t("a11y_theme_light") : t("a11y_theme_dark")}
      aria-pressed={dark}
    >
      <span aria-hidden="true">{dark ? "🌞" : "🌚"}</span>
    </button>
  );
}

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <nav className="navbar" aria-label={t("a11y_main_nav")}>
      <Link to="/" className="navbar-logo">
        MindBlows
      </Link>

      <div className="navbar-links desktop-only">
        <Link to="/">{i18n.t("home")}</Link>
        <Link to="/apps">{i18n.t("apps")}</Link>
        <Link to="/about">{i18n.t("about")}</Link>
        <Link to="/privacy-policy">{i18n.t("privacy")}</Link>
        <ThemeToggle />
      </div>

      <button
        type="button"
        className={`hamburger ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls="mobile-nav"
        aria-label={isOpen ? t("a11y_menu_close") : t("a11y_menu_open")}
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </button>

      <div
        id="mobile-nav"
        className={`navbar-overlay ${isOpen ? "show" : ""}`}
        hidden={!isOpen}
      >
        <div className="navbar-links mobile-only" role="navigation">
          <Link to="/" onClick={() => setIsOpen(false)}>
            {i18n.t("home")}
          </Link>
          <Link to="/apps" onClick={() => setIsOpen(false)}>
            {i18n.t("apps")}
          </Link>
          <Link to="/about" onClick={() => setIsOpen(false)}>
            {i18n.t("about")}
          </Link>
          <Link to="/privacy-policy" onClick={() => setIsOpen(false)}>
            {i18n.t("privacy")}
          </Link>
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
